export enum TupleStatus {
    EMPTY = 0,
    PROCESSING = 1,
    FAILED = 2,
    READY = 3,
}
